import { castArray } from 'lodash-es'

import { ActivationService } from '../components/Activation'
import { ActivitySignService } from '../components/ActivitySign'
import { ActivityTourService } from '../components/ActivityTour'
import { AiReportPopoverService } from '../components/AiReportPopover'
import { VipActivityService } from '../components/VipActivity'
import { GlobalModalService, ServiceWithProps } from '../type/service'

const services = [
  VipActivityService,
  ActivationService,
  ActivitySignService,
  ActivityTourService,
  AiReportPopoverService
]

export const servicePathValid = (path: GlobalModalService['path'], pathname: string) => {
  return castArray(path).some((pathItem) => pathItem === pathname)
}

export const getServices = async (pathname: string) => {
  const validServices = services.filter((service) => {
    return servicePathValid(service.path, pathname)
  })

  if (validServices.length === 0) {
    return
  }

  const promises = validServices.map(async (service) => {
    try {
      const props = await service.registry()

      return {
        service,
        props
      }
    } catch {
      return {
        service,
        props: {
          open: false
        }
      }
    }
  })

  const servicesWithProps = (await Promise.all(promises)) as ServiceWithProps[]

  return servicesWithProps
    .filter((service) => {
      return service.props.open
    })
    .sort((prev, next) => {
      return next.service.priority - prev.service.priority
    })
}
